import { IAccordion } from '$components/Accordion/types';
import { HTMLAttributes, useState } from 'react';

import FadeInSection from '../FadeInSection/FadeInSection';
import { AccordionItem } from './AccordionItem';

export function Accordion(props: IAccordion & HTMLAttributes<HTMLElement>) {
  const { title, content } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  const handleOpenClose = (index) => {
    if (activeIndex === index) setActiveIndex(-1);
    else setActiveIndex(index);
  };

  const renderedAccordions = content.map((item, index) => {
    return (
      <AccordionItem
        key={index}
        title={item.title}
        content={item.content}
        richText={item.richText}
        index={index}
        active={index === activeIndex}
        onClick={() => {
          handleOpenClose(index);
        }}
      />
    );
  });

  return (
    <FadeInSection>
      <div className="flex flex-row justify-center">
        <div className={`grid-standard `}>
          <div
            className={` col-span-4 lg:col-span-6 style-heading-s mb-8 md:mb-0`}
          >
            {title}
          </div>
          <div className={` col-span-4 lg:col-span-6`}>
            {renderedAccordions}
          </div>
        </div>
      </div>
    </FadeInSection>
  );
}
